import { Link } from 'react-router-dom'
import { ArrowRight, Sparkles } from 'lucide-react'
import { AvatarLeaderboard } from '@/components/dashboard/AvatarLeaderboard'
import type { ThemeSpotlight } from '@/hooks/useInstructorStats'
import { formatPrecise } from '@/lib/format'
import { workoutNouns } from '@/lib/discipline'

interface ThemeSpotlightCardProps {
  instructorId: string
  spotlight: ThemeSpotlight
}

// A theme like "80s" can span an instructor's classes across more than
// one discipline, so "workouts" rather than "rides".
const { plural: WORKOUTS } = workoutNouns('all')

export function ThemeSpotlightCard({ instructorId, spotlight }: ThemeSpotlightCardProps) {
  return (
    <div className="flex flex-col gap-4 rounded-xl border border-border bg-card p-6">
      <div className="flex items-center justify-between gap-2">
        <span className="flex items-center gap-1.5 text-xs font-medium uppercase tracking-wide text-muted-foreground">
          <Sparkles className="size-3.5 text-primary" />
          Most common theme
        </span>
        <span className="text-sm text-muted-foreground">
          {formatPrecise(spotlight.ride_count)} {WORKOUTS} tagged &ldquo;{spotlight.theme}&rdquo;
        </span>
      </div>

      <p className="text-sm text-muted-foreground">
        Who shows up most in {spotlight.theme} {WORKOUTS} specifically -- the redundancy check the original
        idea was built around.
      </p>

      <AvatarLeaderboard
        entries={spotlight.top_artists.map((a) => ({
          id: a.id,
          name: a.name,
          image_url: a.image_url,
          count: a.play_count,
        }))}
        valueLabel={WORKOUTS}
      />

      <Link
        to={`/instructors/${instructorId}/themes/${encodeURIComponent(spotlight.theme)}`}
        className="flex items-center gap-1 self-start text-sm font-medium text-primary hover:underline"
      >
        View full {spotlight.theme} breakdown
        <ArrowRight className="size-3.5" />
      </Link>
    </div>
  )
}
